import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { SchoolInfo } from "../school/schoolSlice";

export interface StudentSchoolsState {
  state: LoadStateInfo;
  studentId?: string;
  list?: SchoolInfo[];
}

const initialState: StudentSchoolsState = {
  state: notStarted(),
};

export interface RetrieveStudentSchoolsRequest {
  studentId?: string;
  schoolId?: string;
}
export const retrieveStudentSchools = createAsyncThunk(
  "retrieveStudentSchools",
  async (params: RetrieveStudentSchoolsRequest, thunkAPI) => {
    console.debug(`retrieve classrooms for student ${params.studentId} at school ${params.schoolId}`);

    const response = await fetch(`${getBackendUrl()}/api/student/${params.studentId}/school`, {
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });

    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const studentSchoolsSlice = createSlice({
  name: "studentSchools",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.list = undefined;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(retrieveStudentSchools.pending, (state, action) => {
        state.state =  loading();
        state.list = undefined;
        state.studentId = action.meta.arg.studentId;
      })
      .addCase(retrieveStudentSchools.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
      })
      .addCase(retrieveStudentSchools.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = studentSchoolsSlice.actions;

export const selectStudentSchools = (state: RootState) => state.studentSchools;

export default studentSchoolsSlice.reducer;
